import React, { Component } from "react";
import { Form, Select, Upload, Space, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ButtonItem from "../../../../../Components/ButtonItem";
import axios from "axios";
import ModalItem from "../../../../../Components/ModalItem";
import FormItem from "../../../../../Components/FormItem";
import InputItem from "../../../../../Components/InputItem";
import TextAreaItem from "../../../../../Components/TextAreaItem";
import SelectItem from "../../../../../Components/SelectItem";

const { Option } = Select;

class EditarManual extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    fileList: [],
    uploadedPdfUrl: null,
    cargandoDatos: false,
    manualData: null
  };

  componentDidMount() {
    if (this.props.visible && this.props.manual) {
      this.consultarDatosBack();
    }
  }

  componentDidUpdate(prevProps) {
    const modalSeAbrio = this.props.visible && !prevProps.visible;
    const manualCambio = this.props.manual?._id !== prevProps.manual?._id;
    if (this.props.visible && this.props.manual && (modalSeAbrio || manualCambio)) {
      this.consultarDatosBack();
    }
  }

  consultarDatosBack = async () => {
    const { manual, headersToken } = this.props;
    if (!manual || !manual._id) return;

    this.setState({ cargandoDatos: true });

    try {
      const response = await axios.post(
        "manuales/datosManual",
        { manualId: manual._id },
        headersToken
      );

      if (response.data.success === 2) {
        const m = response.data.manual;

        this.setState({
          manualData: m,
          uploadedPdfUrl: m.pdfUrl,
          fileList: []
        });

        // Cargar los valores reales en el formulario
        if (this.formRef.current) {
          this.formRef.current.setFieldsValue({
            titulo: m.titulo,
            descripcion: m.descripcion,
            categoria: m.categoria,
            paginas: m.paginas,
            orden: m.orden
          });
        }

      } else {
        message.error("No se pudieron cargar los datos del manual");
      }
    } catch (err) {
      console.error(err);
      message.error("Error al consultar datos del manual");
    } finally {
      this.setState({ cargandoDatos: false });
    }
  };

  limpiarFormulario = () => {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({
      fileList: [],
      uploadedPdfUrl: null,
      manualData: null
    });
  };

  getUploadProps = () => ({
    name: "pdf",
    accept: ".pdf",
    maxCount: 1,
    fileList: this.state.fileList,
    beforeUpload: (file) => {
      // Validar que sea PDF
      const isPdf = file.type === 'application/pdf';
      if (!isPdf) {
        message.error('Solo puedes subir archivos PDF');
        return Upload.LIST_IGNORE;
      }

      // Validar tamaño (máximo 10MB)
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error('El archivo debe ser menor a 10MB');
        return Upload.LIST_IGNORE;
      }

      this.setState({ fileList: [file] });
      return false; // No subir automáticamente
    },
    onRemove: () => {
      this.setState({ fileList: [] });
    }
  });

  handleSubmit = async (values) => {
    const { empresaId, onSuccess, headersToken } = this.props;
    const { manualData, fileList } = this.state;

    if (!manualData?._id) {
      message.error("No se pudo identificar el manual a editar.");
      return;
    }

    this.setState({ loading: true });

    try {
      let pdfUrl = manualData.pdfUrl;

      // Solo subir nuevo PDF si el usuario seleccionó uno
      if (fileList.length > 0) {
        const rawFile = fileList[0];
        const cleanedFile = new File([rawFile], rawFile.name, {
          type: rawFile.type
        });

        const formData = new FormData();
        formData.append("pdf", cleanedFile);

        const uploadResponse = await axios.post(
          "/manuales/uploadPDF",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              ...headersToken.headers
            }
          }
        );

        if (uploadResponse.data.success !== 2) {
          message.error("Error al subir el nuevo PDF");
          this.setState({ loading: false });
          return;
        }

        pdfUrl = uploadResponse.data.pdfUrl;
      }

      const payload = {
        ...values,
        empresaId,
        pdfUrl,
        manualId: manualData._id
      };

      const response = await axios.post(
        "manuales/editarManual",
        payload,
        headersToken
      );

      if (response.data.success === 2) {
        message.success("Manual editado correctamente");
        this.limpiarFormulario();
        onSuccess();
      } else {
        message.error(response.data.message || "Error al editar manual");
      }

    } catch (error) {
      console.error(error);
      message.error("Error al conectar con el servidor");
    } finally {
      this.setState({ loading: false });
    }
  };

  handleCancel = () => {
    this.limpiarFormulario();
    this.props.onCancel();
  };

  render() {
    const { visible } = this.props;
    const { loading, cargandoDatos, manualData } = this.state;

    return (
      <ModalItem
        title="Editar Manual"
        visible={visible}
        spinning={loading || cargandoDatos}
        onCancel={this.handleCancel}
        footer={null}
        width={600}
        destroyOnClose
      >
        <Form
          ref={this.formRef}
          layout="vertical"
          onFinish={this.handleSubmit}
        >
          <FormItem
            name="titulo"
            label="Título"
            rules={[
              { required: true, message: "Ingresa el título" },
              { max: 100, message: "Máximo 100 caracteres" }
            ]}
          >
            <InputItem placeholder="Ej: Manual de Usuario" />
          </FormItem>

          <FormItem
            name="descripcion"
            label="Descripción"
            rules={[
              { required: true, message: "Ingresa la descripción" }
            ]}
          >
            <TextAreaItem rows={3} placeholder="Breve descripción" />
          </FormItem>

          <FormItem
            name="categoria"
            label="Categoría"
            rules={[{ required: true, message: "Selecciona una categoría" }]}
          >
            <SelectItem placeholder="Selecciona una categoría">
              <Option value="General">General</Option>
              <Option value="Configuración">Configuración</Option>
              <Option value="Técnico">Técnico</Option>
              <Option value="Contabilidad">Contabilidad</Option>
              <Option value="Fiscal">Fiscal</Option>
              <Option value="Reportes">Reportes</Option>
            </SelectItem>
          </FormItem>

          <FormItem
            name="paginas"
            label="Número de Páginas"
            rules={[{ required: true, message: "Ingresa el número de páginas" }]}
          >
            <InputItem placeholder="Ej: 45 páginas" />
          </FormItem>

          <FormItem
            name="orden"
            label="Orden de visualización"
            tooltip="Menor número = aparece primero"
          >
            <InputItem type="number" placeholder="0" min={0} />
          </FormItem>

          <FormItem
            label="Reemplazar archivo PDF (opcional)"
            extra={
              manualData?.pdfUrl 
                ? "PDF actual disponible. Sube uno nuevo solo si deseas reemplazarlo."
                : "Si no seleccionas nada, se conserva el PDF actual"
            }
          >
            <Upload {...this.getUploadProps()}>
              <ButtonItem icon={<UploadOutlined />}>
                {this.state.fileList.length > 0 ? "Cambiar PDF" : "Subir nuevo PDF"}
              </ButtonItem>
            </Upload>
          </FormItem>

          <FormItem style={{ marginBottom: 0, marginTop: 24 }}>
            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <ButtonItem onClick={this.handleCancel}>Cancelar</ButtonItem>
              <ButtonItem type="primary" htmlType="submit" loading={loading}>
                Guardar cambios
              </ButtonItem>
            </Space>
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

export default EditarManual;